"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spanTexts = exports.bodyText = exports.code1 = exports.heading1 = exports.heading2 = exports.heading3 = exports.heading4 = exports.heading5 = exports.heading6 = exports.heading7 = exports.pageSectionHeader = exports.pageTitle = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var pageTitle = function pageTitle(_ref) {
  var children = _ref.children,
      dataAttribute = _ref.dataAttribute;
  return /*#__PURE__*/_react.default.createElement("h5", {
    role: _constants.headingRole,
    className: _constants.classes.pageTitle,
    "data-auto-id": dataAttribute
  }, children);
};

exports.pageTitle = pageTitle;

var pageSectionHeader = function pageSectionHeader(_ref2) {
  var children = _ref2.children,
      dataAttribute = _ref2.dataAttribute;
  return /*#__PURE__*/_react.default.createElement("h3", {
    role: _constants.headingRole,
    className: _constants.classes.pageSectionHeader,
    "data-auto-id": dataAttribute
  }, children);
};

exports.pageSectionHeader = pageSectionHeader;

var heading7 = function heading7(_ref3) {
  var children = _ref3.children,
      dataAttribute = _ref3.dataAttribute;
  return /*#__PURE__*/_react.default.createElement("h6", {
    role: _constants.headingRole,
    className: _constants.classes.heading7,
    "data-auto-id": dataAttribute
  }, children);
};

exports.heading7 = heading7;

var heading6 = function heading6(_ref4) {
  var children = _ref4.children,
      dataAttribute = _ref4.dataAttribute;
  return /*#__PURE__*/_react.default.createElement("h4", {
    role: _constants.headingRole,
    className: _constants.classes.heading6,
    "data-auto-id": dataAttribute
  }, children);
};

exports.heading6 = heading6;

var heading5 = function heading5(_ref5) {
  var children = _ref5.children,
      dataAttribute = _ref5.dataAttribute;
  return /*#__PURE__*/_react.default.createElement("h3", {
    role: _constants.headingRole,
    className: _constants.classes.heading5,
    "data-auto-id": dataAttribute
  }, children);
};

exports.heading5 = heading5;

var heading4 = function heading4(_ref6) {
  var children = _ref6.children,
      dataAttribute = _ref6.dataAttribute;
  return /*#__PURE__*/_react.default.createElement("h2", {
    role: _constants.headingRole,
    className: _constants.classes.heading4,
    "data-auto-id": dataAttribute
  }, children);
};

exports.heading4 = heading4;

var heading3 = function heading3(_ref7) {
  var children = _ref7.children,
      dataAttribute = _ref7.dataAttribute;
  return /*#__PURE__*/_react.default.createElement("h1", {
    role: _constants.headingRole,
    className: _constants.classes.heading3,
    "data-auto-id": dataAttribute
  }, children);
};

exports.heading3 = heading3;

var heading2 = function heading2(_ref8) {
  var children = _ref8.children,
      dataAttribute = _ref8.dataAttribute;
  return /*#__PURE__*/_react.default.createElement("h1", {
    role: _constants.headingRole,
    className: _constants.classes.heading2,
    "data-auto-id": dataAttribute
  }, children);
};

exports.heading2 = heading2;

var heading1 = function heading1(_ref9) {
  var children = _ref9.children,
      dataAttribute = _ref9.dataAttribute;
  return /*#__PURE__*/_react.default.createElement("h1", {
    role: _constants.headingRole,
    className: _constants.classes.heading1,
    "data-auto-id": dataAttribute
  }, children);
};

exports.heading1 = heading1;

var code1 = function code1(_ref10) {
  var children = _ref10.children,
      dataAttribute = _ref10.dataAttribute;
  return /*#__PURE__*/_react.default.createElement("code", {
    role: _constants.figureRole,
    "aria-labelledby": _constants.codeAriaLabelledBy,
    className: _constants.classes.code1,
    "data-auto-id": dataAttribute
  }, children);
};

exports.code1 = code1;

var bodyText = function bodyText(_ref11) {
  var children = _ref11.children,
      dataAttribute = _ref11.dataAttribute;
  return /*#__PURE__*/_react.default.createElement("p", {
    className: _constants.classes.bodyText,
    "data-auto-id": dataAttribute
  }, children);
};

exports.bodyText = bodyText;

var spanTexts = function spanTexts(_ref12) {
  var _labelClasses;

  var variant = _ref12.variant,
      children = _ref12.children,
      dataAttribute = _ref12.dataAttribute;
  var buttonLabel = _constants.typographyVariants.buttonLabel,
      label1 = _constants.typographyVariants.label1,
      label2 = _constants.typographyVariants.label2,
      caption1 = _constants.typographyVariants.caption1,
      helperText1 = _constants.typographyVariants.helperText1;
  var labelClasses = (_labelClasses = {}, _defineProperty(_labelClasses, _constants.classes.buttonLabel, variant === buttonLabel), _defineProperty(_labelClasses, _constants.classes.label1, variant === label1), _defineProperty(_labelClasses, _constants.classes.label2, variant === label2), _defineProperty(_labelClasses, _constants.classes.caption1, variant === caption1), _defineProperty(_labelClasses, _constants.classes.helperText1, variant === helperText1), _labelClasses);

  var spanTitle = function spanTitle() {
    if (typeof children === 'string') {
      return children;
    }

    return '';
  };

  return /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(_objectSpread({}, labelClasses)),
    "data-auto-id": dataAttribute,
    title: spanTitle()
  }, children);
};

exports.spanTexts = spanTexts;